import { ResponsiveLine } from '@nivo/line';

const _gridYValues = (minValue?: number, maxValue?: number) => {
    const step = maxValue! - minValue!;
    const scale = [minValue, step / 4, (step * 2) / 4, (step * 3) / 4, maxValue];
    return scale;
};

const margin = {
    top: 30,
    right: 10,
    bottom: 30,
    left: 10,
};

const NivoNakedLineChart = ({
    data,
    minValue,
    maxValue,
    noAnimate,
}: {
    data: any;
    minValue?: number;
    maxValue?: number;
    noAnimate?: boolean;
}) => {
    if (!Array.isArray(data)) {
        return (
            <div className="chart-message">
                <span>Invalid chart data</span>
            </div>
        );
    }

    const yScale: any = {
        type: 'linear',
        stacked: true,
        min: minValue !== null ? minValue : 'auto',
        max: maxValue !== null ? maxValue : 'auto',
    };

    const gridYValues: any =
        minValue !== null && maxValue !== null ? _gridYValues(minValue, maxValue) : null;

    return (
        <ResponsiveLine
            animate={noAnimate !== true}
            useMesh
            data={data}
            margin={margin}
            curve="monotoneX"
            enableGridX={false}
            enableGridY
            isInteractive={false}
            lineWidth={4}
            xScale={{ type: 'point' }}
            yScale={yScale}
            axisTop={null}
            axisRight={null}
            axisBottom={null}
            axisLeft={null}
            colors={{ scheme: 'category10' }}
            pointSize={0}
            pointColor={{ theme: 'background' }}
            pointBorderWidth={2}
            pointBorderColor={{ from: 'serieColor' }}
            pointLabel="y"
            pointLabelYOffset={-12}
            legends={[]}
            gridYValues={gridYValues}
        />
    );
};

export default NivoNakedLineChart;
